import { List } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";
import { Typography } from "components/typography";
import { StyledLinkButton } from "./StyledLinkButton";
import { NotificationDisplayItem } from "./notifications.types";
import { NotificationEntry } from "./NotificationEntry";
import { EmptyState } from "./EmptyState";
import { MAX_NOTIFICATIONS_IN_POPUP } from "./notifications.constants";

interface PopupWindowProps {
  icbtCommunications?: NotificationDisplayItem[];
  onClose?: () => void;
}

export const PopupWindow = ({
  icbtCommunications,
  onClose,
}: PopupWindowProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <WindowContainer>
      <Top>
        <Header variant="h3">{t("ICBT_FEEDBACK_DUE_TODAY")}</Header>
        {icbtCommunications && icbtCommunications?.length > 0 ? (
          <StyledList>
            {icbtCommunications
              .slice(0, MAX_NOTIFICATIONS_IN_POPUP)
              .map((icbtCommunication) => (
                <NotificationEntry
                  key={icbtCommunication.request_id}
                  icbtCommunication={icbtCommunication}
                  onClick={() => onClose?.()}
                />
              ))}
          </StyledList>
        ) : (
          <EmptyState />
        )}
      </Top>
      <Footer>
        <StyledLinkButton
          onPress={() => {
            navigate("/icbt-feedback");
            onClose?.();
          }}
        >
          {t("VIEW_ALL")}
        </StyledLinkButton>
      </Footer>
    </WindowContainer>
  );
};

const WindowContainer = styled.div`
  width: 29vw;
  max-width: 400px;
  background-color: ${({ theme }) => theme.COLORS.WHITE};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
`;

const Header = styled(Typography)`
  margin-top: ${({ theme }) => theme.PADDING.SM};
  margin-left: ${({ theme }) => theme.PADDING.MD};
  padding-bottom: ${({ theme }) => theme.PADDING.SM};
`;

const StyledList = styled(List)`
  padding: 0;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 55px;
  min-height: 55px;
  width: 100%;
`;
